import config from 'config';
import { TrackingService } from './TrackingService';
import { SearchFormSubmitService, SubmitItem } from './SearchFormSubmitService';
import { requireShopSystem } from '../../../declarations/runtimeExports';
import VisibilityService from './VisibilityService';
import HandleShopInteractionService from './HandleShopInteractionService';

const shopSystem = requireShopSystem();

export enum InteractionBlockTypes {
    product = 'product',
    suggest = 'suggest',
    promotion = 'promotion',
    cat = 'cat',
    landingpage = 'landingpage',
    vendor = 'vendor',
}

class HandleInteraction {
    private readonly handleShopInteractionService;
    private readonly block: string;
    private readonly blockLabel: string;
    private value: string;
    private url: string;

    public constructor(handleShopInteractionService: HandleShopInteractionService, block: string, blockLabel: string = null) {
        this.handleShopInteractionService = handleShopInteractionService;
        this.block = block;
        this.blockLabel = blockLabel;
    }

    private createSubmitItem(): SubmitItem {
        return {
            block: this.block,
            blockLabel: this.blockLabel,
            value: this.value,
            label: this.value,
            url: this.url,
        } as SubmitItem;
    }

    public withValue(value: string): HandleInteraction {
        this.value = value;

        return this;
    }

    public withUrl(value: string, url: string): HandleInteraction {
        this.url = value === 'product' ? shopSystem.fixProductUrl(config, url) : url;
        this.value = value;

        return this;
    }

    public submit(submitItem: SubmitItem = null): void {
        submitItem = submitItem || this.createSubmitItem();
        SearchFormSubmitService.submit(submitItem, this.handleShopInteractionService.getActiveInputField());
        VisibilityService.hide();
    }

    public trackAndSubmit(): Promise<void> {
        const submitItem = this.createSubmitItem();

        return TrackingService.trackInteraction(submitItem, this.handleShopInteractionService.getActiveInputValue()).then(() =>
            this.submit(submitItem)
        );
    }
}

export class HandleInteractionService {
    private readonly handleShopInteractionService;

    public constructor(handleShopInteractionService: HandleShopInteractionService) {
        this.handleShopInteractionService = handleShopInteractionService;
    }

    public byBlock(block: string, blockLabel: string = null): HandleInteraction {
        const usedLabel = blockLabel || config.blocks[block] || block;

        return new HandleInteraction(this.handleShopInteractionService, block, usedLabel);
    }

    public byQuery(query: string = null): HandleInteraction {
        if (query) {
            this.handleShopInteractionService.setActiveInputValue(query);
        }

        const service = this.byBlock(InteractionBlockTypes.suggest, 'Query');
        service.withValue(this.handleShopInteractionService.getActiveInputValue());

        return service;
    }
}
